import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import Fab from "@material-ui/core/Fab";
import {getTranslation} from "../../helpers/get-translation";
import {hintsModal} from "../../helpers/modal-builder";
import {IS_DEVICE_MOBILE} from "../../helpers/mobile";

const styles = theme => ({
	root: {
		padding: "0 0 0 16px",
		display: 'flex',
		justifyContent: 'center',
		alignItems: "center"
	},
	answerInput: {
		marginTop: "5px",
		height: "45px",
		width:'100%',
		fontSize: "2em",
		'& i':{
			fontSize: "1em",
		}
	},
	validateAnswer: {
		display: "flex",
		'& button' : {
			boxShadow: "none",
			color: "white !important",
			width: '50px',
			'min-width': '50px',
			height: '50px',
			padding: '12px',
		},

		"& #validate-answer-container":{
			paddingRight: "16px",
			paddingLeft: "5px",

			"& > button": {
				backgroundColor: "#007bff !important",

				"& img": {
					width: "26px"
				}
			},

			"& > button.hover": {
				backgroundColor: "#0052ab !important"
			},
		},

		"& #hints-button-container": {
			paddingRight: "5px",

			"& > button": {
				backgroundColor: "#fe4365 !important",

				"& img": {
					width: "16px"
				},
			},

			"& > button.hover": {
				backgroundColor: "#c64e64 !important",
			}
		}
	},
	buttonContainer:{
		padding: "10px",
		cursor: "pointer",
		"-webkit-tap-highlight-color": "transparent",

		"& button:active": {
			boxShadow: "none"
		},

		"& > *":{
			pointerEvents: "none"
		}
	},
	answerRow: {
		display: 'flex',
	},
	"@media (max-width: 540px)": {
		answerInput: {
			fontSize: "1.5em",
			width:'80%',
		},
	}
});

class AnswerInput extends Component {
	input = React.createRef();
	state = {
		isHintsContainerHovered: false,
		isAnswerContainerHovered: false,
	};

	componentDidMount() {
		document.querySelector('#answer-input-container').addEventListener("focus", (e) => {
			let i = 0;
			const interval = setInterval(function(){
				window.scrollTo(0, 0);
				document.body.scrollTop = 0;
				i++;
				if(i>10){
					clearInterval(interval);
				}
			},10);
		});

		document.querySelector('#answer-input-container').focus();

		const hintsContainer = document.querySelector('#hints-button-container');
		const validateAnswerContainer = document.querySelector('#validate-answer-container');

		if(IS_DEVICE_MOBILE){
			hintsContainer.addEventListener("touchend", this.onMouseClick);
			validateAnswerContainer.addEventListener("touchend", this.onMouseClick);
		} else {
			this.addButtonMouseHoverListener(hintsContainer);
			this.addButtonMouseHoverListener(validateAnswerContainer);
		}
	}

	addButtonMouseHoverListener = (element) => {
		element.addEventListener("mouseenter", this.onMouseEnter);
		element.addEventListener("mouseleave", this.onMouseLeave);
	};

	componentWillUnmount() {
		const hintsContainer = document.querySelector('#hints-button-container');
		const validateAnswerContainer = document.querySelector('#validate-answer-container');
		if(IS_DEVICE_MOBILE){
			hintsContainer.removeEventListener("touchend", this.onMouseClick);
			validateAnswerContainer.removeEventListener("touchend", this.onMouseClick);
		} else {
			this.removeButtonMouseHoverListener(hintsContainer);
			this.removeButtonMouseHoverListener(validateAnswerContainer);
		}
	}

	onMouseClick = ({target}) => {
		const timeOutFunc = () => {
			setTimeout(() => this.toggleHover(target.id, false), 200)
		};
		this.toggleHover(target.id, true, timeOutFunc)
	};

	removeButtonMouseHoverListener = (element) => {
		element.removeEventListener("mouseenter", this.onMouseEnter);
		element.removeEventListener("mouseleave", this.onMouseLeave);
	};

	onMouseEnter = ({ target }) => {
		this.toggleHover(target.id, true)
	};

	onMouseLeave = ({ target }) => {
		this.toggleHover(target.id, false)
	};

	toggleHover = (id, state, func=() => null) => {
		if(id === "hints-button-container"){
			this.setState({ isHintsContainerHovered: state }, func)
		} else if(id === "validate-answer-container"){
			this.setState({ isAnswerContainerHovered: state }, func)
		}
	};

	componentDidUpdate(prevProps, prevState, snapshot){
		const input = document.querySelector(`#answer-input-container`);
		if(this.props.isChecking && prevProps.isChecking !== this.props.isChecking){
			input.focus();
		} else if(prevProps.isModalOpen === true && this.props.isModalOpen === false){
			input.focus();
		}
	}

	onFocus = () => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	};

	onAnswerClick = (e) => {
		e.preventDefault();
		e.target.blur();
		this.props.handleSubmit(e);
		document.querySelector('#answer-input-container').focus();
	};

	render() {
		const { classes, userAnswer, onChange, isChecking, addModalWindow } = this.props;
		const { isHintsContainerHovered, isAnswerContainerHovered } = this.state;

		return (
			<div className={classes.root}>
				<Input
					id="answer-input-container"
					placeholder={getTranslation("game_input_placeholder")}
					className={classes.answerInput}
					value={userAnswer}
					onChange={onChange}
					// onFocus={this.onFocus}
					autoFocus={false}
					autoComplete={"off"}
				/>
				<div className={classes.validateAnswer}>
					<div className={classes.buttonContainer}
						 onClick={() => addModalWindow(hintsModal())}
						 id="hints-button-container">
						<Fab
							disabled={isChecking}
							className={isHintsContainerHovered ? "hover": ""}
						>
							<img src={getTranslation("image_buy_hints_button")} />
						</Fab>
					</div>

					<div className={classes.buttonContainer}
						 onClick={this.onAnswerClick}
						 id="validate-answer-container">
						<Fab
							disabled={isChecking}
							className={isAnswerContainerHovered ? "hover": ""}
						>
							<img src={getTranslation("image_answer_guess_button")} />
						</Fab>
					</div>
				</div>
			</div>
		);

	}
}

AnswerInput.propTypes = {
	userAnswer: PropTypes.string.isRequired,
	isChecking: PropTypes.bool.isRequired,
	isModalOpen: PropTypes.bool.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		answerInput: PropTypes.string.isRequired,
		validateAnswer: PropTypes.string.isRequired,
	}).isRequired,

	addModalWindow: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired
};

export default withStyles(styles)(AnswerInput);
